export default __webpack_public_path__ + "static/media/img5.31a15b05.jpg";